// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-section-draft-list {
  flex-direction: column;
  height: 100%;
}
app-section-draft-list #search {
  width: 100%;
  height: 100% !important;
  overflow: auto !important;
}
app-section-draft-list .text {
  padding-right: 14px;
}
app-section-draft-list mat-card {
  width: 285px !important;
}
app-section-draft-list .draft-container {
  display: block !important;
  margin-top: 0 !important;
}
app-section-draft-list .owner-icon {
  width: 27px;
  height: 27px;
  background: #4A4A4A;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  vertical-align: sub;
  margin-right: 6px;
}
app-section-draft-list .template-name {
  font-size: 12px;
  font-weight: bold;
  text-decoration: underline;
}
app-section-draft-list .section-name {
  font-size: 12px;
  font-weight: bold;
  margin-top: 15px;
}
app-section-draft-list .bottom-text {
  margin-top: 3em !important;
}
app-section-draft-list .creation-date {
  font-size: 12px;
}
app-section-draft-list .section-type {
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(74, 74, 74, 0.5);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  line-height: 32px;
  font-size: 10px;
}
app-section-draft-list .research-draft-card {
  border-radius: 10px;
  width: 325px;
  display: inline-block;
  margin: 10px;
  padding: 0;
  cursor: pointer;
}
app-section-draft-list .file-uploader {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
app-section-draft-list .action-button {
  position: absolute;
  right: -5px;
  top: 0;
}
app-section-draft-list #search {
  width: 100%;
}
app-section-draft-list #search ul {
  list-style: none;
  padding: 0px;
  margin-top: 72px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}
app-section-draft-list #search .search-box {
  background-color: #ffffff;
  position: relative;
  border-radius: 10px;
  width: 325px;
  overflow: hidden;
}
app-section-draft-list #search .search-box .search-head {
  list-style: none;
  padding: 10px;
  margin: 0px;
  background-color: #f4f4f4;
  display: flex;
  justify-content: space-between;
}
app-section-draft-list #search .search-box .search-head .text {
  color: #4A4A4A;
  font-family: "nexabold";
  font-size: 14px;
  line-height: 26px;
}
app-section-draft-list #search .search-box .search-content {
  background-color: #ffffff;
  padding: 15px;
  position: relative;
}
app-section-draft-list #search .search-box .search-content h2.head-link {
  font-family: "nexabold";
  line-height: normal;
  font-size: 14px;
  text-decoration-line: underline;
  color: #000000;
  margin: 0;
  margin-bottom: 10px;
}
app-section-draft-list #search .search-box .search-content h2.head-link a {
  color: inherit;
}
app-section-draft-list #search .search-box .search-content .project-list {
  list-style: disc;
  padding-left: 15px;
  margin: 0px;
  font-family: "nexabold";
  line-height: normal;
  font-size: 14px;
  width: auto;
  display: block;
}
app-section-draft-list #search .search-box .search-content .color-btn {
  list-style: none;
  padding: 0px;
  margin: 0px;
  float: right;
  display: block;
  position: absolute;
  right: 0px;
  width: 110px;
  top: 15px;
  right: 15px;
}
app-section-draft-list #search .search-box .search-content .color-btn li {
  display: block;
  text-align: center;
  width: 100%;
}
app-section-draft-list #search .search-box .search-content .color-btn li button {
  background-color: #FFFFFF;
  border: 0.5px solid #00D3CC;
  box-sizing: border-box;
  border-radius: 14px;
  font-family: "nexa";
  font-size: 14px;
  letter-spacing: 0.145455px;
  color: #00D3CC;
  padding: 5px;
  text-align: center;
  width: 100%;
  margin-bottom: 12px;
}
app-section-draft-list #search .search-box .search-content .color-btn li button img {
  margin-right: 10px;
}
app-section-draft-list #search .search-box .search-content .bottom-text {
  margin-top: 8em;
}
app-section-draft-list #search .search-box .search-content .bottom-text h2 {
  font-family: "nexabold";
  font-size: 14px;
  margin: 0;
  line-height: 20px;
}
app-section-draft-list #search .search-box .search-content .bottom-text h2 img {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/research-sheet/core/section-draft-display/section-draft-list/section-draft-list.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;EACA,uBAAA;EACA,yBAAA;AACR;AAEI;EACI,mBAAA;AAAR;AAGE;EACI,uBAAA;AADN;AAIE;EACI,yBAAA;EACA,wBAAA;AAFN;AAKI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAHR;AAMI;EACI,eAAA;EACA,iBAAA;EACA,0BAAA;AAJR;AAOI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AALR;AAQI;EACI,0BAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AARR;AAWI;EACI,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AATR;AAYI;EACI,eAAA;EACA,YAAA;EACA,WAAA;AAVR;AAaI;EACI,kBAAA;EACA,WAAA;EACA,MAAA;AAXR;AAcI;EACI,WAAA;AAZR;AAcQ;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAZZ;AAeQ;EACI,yBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,YAAA;EACA,gBAAA;AAdZ;AAgBY;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;AAdhB;AAgBgB;EACI,cAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAdpB;AAkBY;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;AAhBhB;AAkBgB;EACI,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAhBpB;AAkBoB;EACI,cAAA;AAhBxB;AAqBgB;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAnBpB;AAsBgB;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AApBpB;AAsBoB;EACI,cAAA;EACA,kBAAA;EACA,WAAA;AApBxB;AAsBwB;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AApB5B;AAsB4B;EACI,kBAAA;AApBhC;AA0BgB;EACI,eAAA;AAxBpB;AA0BoB;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AAxBxB;AA0BwB;EACI,kBAAA;AAxB5B","sourcesContent":["app-section-draft-list {\n    flex-direction: column;\n    height: 100%;\n\n    #search {\n        width: 100%;\n        height: 100% !important;\n        overflow: auto !important;\n    }\n\n    .text {\n        padding-right: 14px;\n    }\n\n  mat-card {\n      width: 285px !important;\n  }\n\n  .draft-container {\n      display: block !important;\n      margin-top: 0 !important;\n  }\n\n    .owner-icon {\n        width: 27px;\n        height: 27px;\n        background: #4A4A4A;\n        border-radius: 50%;\n        color: white;\n        font-size: 18px;\n        line-height: 27px;\n        text-align: center;\n        vertical-align: sub;\n        margin-right: 6px;\n    }\n\n    .template-name {\n        font-size: 12px;\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .section-name {\n        font-size: 12px;\n        font-weight: bold;\n        margin-top: 15px;\n    }\n\n    .bottom-text {\n        margin-top: 3em !important;\n    }\n\n    .creation-date {\n        font-size: 12px;\n    }\n\n    .section-type {\n        background: #FFFFFF;\n        box-shadow: 0px 0px 10px rgba(74, 74, 74, 0.5);\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        text-align: center;\n        line-height: 32px;\n        font-size: 10px;\n    }\n\n    .research-draft-card {\n        border-radius: 10px;\n        width: 325px;\n        display: inline-block;\n        margin: 10px;\n        padding: 0;\n        cursor: pointer;\n    }\n\n    .file-uploader {\n        position: fixed;\n        bottom: 10px;\n        right: 10px;\n    }\n\n    .action-button {\n        position: absolute;\n        right: -5px;\n        top: 0;\n    }\n\n    #search {\n        width: 100%;\n\n        ul {\n            list-style: none;\n            padding: 0px;\n            margin-top: 72px;\n            display: flex;\n            width: 100%;\n            justify-content: space-around;\n        }\n\n        .search-box {\n            background-color: #ffffff;\n            position: relative;\n            //box-shadow: 0px 2px 20px rgba(161, 161, 161, 0.07);\n            border-radius: 10px;\n            width: 325px;\n            overflow: hidden;\n\n            .search-head {\n                list-style: none;\n                padding: 10px;\n                margin: 0px;\n                background-color: #f4f4f4;\n                display: flex;\n                justify-content: space-between;\n\n                .text {\n                    color: #4A4A4A;\n                    font-family: 'nexabold';\n                    font-size: 14px;\n                    line-height: 26px;\n                }\n            }\n\n            .search-content {\n                background-color: #ffffff;\n                padding: 15px;\n                position: relative;\n\n                h2.head-link {\n                    font-family: 'nexabold';\n                    line-height: normal;\n                    font-size: 14px;\n                    text-decoration-line: underline;\n                    color: #000000;\n                    margin: 0;\n                    margin-bottom: 10px;\n\n                    a {\n                        color: inherit;\n                    }\n\n                }\n\n                .project-list {\n                    list-style: disc;\n                    padding-left: 15px;\n                    margin: 0px;\n                    font-family: 'nexabold';\n                    line-height: normal;\n                    font-size: 14px;\n                    width: auto;\n                    display: block;\n                }\n\n                .color-btn {\n                    list-style: none;\n                    padding: 0px;\n                    margin: 0px;\n                    float: right;\n                    display: block;\n                    position: absolute;\n                    right: 0px;\n                    width: 110px;\n                    top: 15px;\n                    right: 15px;\n\n                    li {\n                        display: block;\n                        text-align: center;\n                        width: 100%;\n\n                        button {\n                            background-color: #FFFFFF;\n                            border: 0.5px solid #00D3CC;\n                            box-sizing: border-box;\n                            border-radius: 14px;\n                            font-family: 'nexa';\n                            font-size: 14px;\n                            letter-spacing: 0.145455px;\n                            color: #00D3CC;\n                            padding: 5px;\n                            text-align: center;\n                            width: 100%;\n                            margin-bottom: 12px;\n\n                            img {\n                                margin-right: 10px;\n                            }\n                        }\n                    }\n                }\n\n                .bottom-text {\n                    margin-top: 8em;\n\n                    h2 {\n                        font-family: 'nexabold';\n                        font-size: 14px;\n                        margin: 0;\n                        line-height: 20px;\n\n                        img {\n                            margin-right: 10px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
